{
  "instances": {
    "liquibase": {
      "label": "Liquibase",
      "author": "Autor",
      "changelog": "Registro de cambios",
      "checksum": "Checksum",
      "comments": "Comentarios",
      "contexts": "Contextos",
      "deployment_id": "Despliegue Id",
      "description": "Descripción",
      "execution": "Ejecución",
      "execution_date": "Fecha de Ejecución",
      "execution_order": "Órden de Ejecución",

      "id": "Id",
      "labels": "Etiquetas",
      "tag": "Tag"
    }
  }
}
